import { createContext, useContext, useEffect, useRef } from 'react'
import { useAppState } from '../../containers/app/AppState/AppState'

/**
 * @param {{ chosenPlan, successPath, marketingSource }} options
 */
const useWizardStateManagement = (options) => {
  const { chosenPlan, setChosenPlan } = useAppState()
  useEffect(() => {
    if (options.chosenPlan) {
      setChosenPlan(options.chosenPlan)
    }
  }, [])
  const optionsRef = useRef(options)
  return {
    ...optionsRef.current,
    chosenPlan,
    setChosenPlan,
  }
}

const WizardStateContext = createContext()

export const WizardStateProvider = ({ children, ...props }) => {
  const wizardState = useWizardStateManagement(props)
  return <WizardStateContext.Provider value={wizardState}>{children}</WizardStateContext.Provider>
}

export const useWizardState = () => useContext(WizardStateContext)
